import { navigate } from 'gatsby-link';
import { map } from 'ramda';
import React, { FC } from 'react';
import styled from 'styled-components';

import Eyebrow from '@ui/atoms/Eyebrow';
import TextButton from '@ui/atoms/TextButton';

import { INavItem } from '@folx-types/dashboard';

import theme from '@theme/FolxTheme';

interface INavRowProps {
	items: INavItem[];
	currentPath?: string;
}

const NavSection = styled.ul`
	display: flex;
	gap: ${theme.spacing.md};

	& > li > ${TextButton} {
		& > ${Eyebrow} {
			margin: ${theme.spacing.xs} 0;
			cursor: pointer;
		}
	}

	@media ${theme.responsive.breakpoints.laptopM} {
		gap: ${theme.spacing.lg};
	}
`;

const NavRow: FC<INavRowProps> = ({ items, currentPath }) => {
	const getNavItem = (item: INavItem) => {
		const activeTab = item.pathName;
		const hasActiveDecoration = activeTab === currentPath;
		const clickHandler = () => {
			return item.external ? window.open(item.pathName) : navigate(item.pathName);
		};

		if (item.mobileOnly) return;

		return (
			<li role="presentation">
				<TextButton
					role="menuitem"
					key={item.header}
					label={item.header}
					underline={hasActiveDecoration}
					onClick={clickHandler}
				/>
			</li>
		);
	};

	return (
		<NavSection role="menubar" aria-label="Member Dashboard Sections">
			{map(getNavItem, items)}
		</NavSection>
	);
};

export default NavRow;
